<div class="card-container-header">
  <h2 class="title-card-bold" [class]="titleClasses">
    {{'transactions.transactions-title-with-pagination.header' | translate}}
  </h2>
  <div class="navigation-container ml-auto navigation-container-defi">
    <div class="navigation-block">
      <div class="navigation-body magic-crutch">
        <span class="navigation-list">
          {{ 1 + (itemsPerPage * page - itemsPerPage) }}
          —
          {{ itemsPerPage * page > total ? total : itemsPerPage * page }}
          of {{ total }}</span
        >

        <div class="navigation-block-popup">
          <ul>
            <li [class.active]="desc === 1" (click)="descChange.emit(1)">
              <a href="javascript:void(0)">{{'transactions.transactions-title-with-pagination.newest' | translate}}</a>
            </li>
            <li [class.active]="desc === 0">
              <a href="javascript:void(0)" (click)="descChange.emit(0)"
                >{{'transactions.transactions-title-with-pagination.oldest' | translate}}</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div>
        <i
          class="icon2 icon2-arrow-top left"
          (click)="page > 1 && pageChange.emit(page - 1)"
        ></i>
        <i
          class="icon2 icon2-arrow-top right"
          (click)="itemsPerPage * page < total && pageChange.emit(page + 1)"
        ></i>
      </div>
      <ng-container
        *ngIf="loading"
        [ngTemplateOutlet]="svgPreloaderSm"
      ></ng-container>
    </div>
    <div class="card-header-dropdown">
      <span class="title-dropdown">{{'transactions.transactions-title-with-pagination.show-per-page' | translate}}</span>
      <app-dropdown
        classes="dropdown dropdown-form-control dropdown-form-control-sm"
        [items]="[10, 15, 20, 25, 30]"
        [selected]="itemsPerPage"
        (selectedChange)="itemsPerPageChange.emit($event)"
        placeholder=""
      >
        <ng-template #phTemplate let-selected="selected">
          <div class="media media-table">{{ selected }}</div>
        </ng-template>

        <ng-template #optionTemplate let-item let-select="select">
          <span
            class="dropdown-item dropdown-item-lender"
            (click)="select(item)"
          >
            {{ item }}
          </span>
        </ng-template>
      </app-dropdown>
    </div>
  </div>
</div>

<ng-template #svgPreloaderSm>
  <svg viewBox="0 0 30 30" class="svg-preloader-sm">
    <symbol id="s-circle-sm">
      <circle r="5" cx="5" cy="5"></circle>
    </symbol>
    <rect class="r-bounds-sm" width="100%" height="100%"></rect>
    <g id="circle-sm" class="g-circles-sm">
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
      <use xlink:href="#s-circle-sm" class="u-circle-sm"></use>
    </g>
  </svg>
</ng-template>
